export { default as DocumentSolidIcon } from './DocumentSolidIcon';
